import Axios from 'axios'
const ServiceUrl='https://webbackadminapi.jiantu99.com';
//const ServiceUrl='http://ht.jiantujianzhi.com';
//const ServiceUrl='http://localhost:8087';
function Post(res){

    const name=res.name;
    const action=res.action;
    const data=res.data;
    const fail=res.fail;
    const success=res.success;
    const complete=res.complete;
    const notstorage=res.notstorage||false;
    let retdata={
        data:data
    }

    if(!notstorage)
    {
        let isLogin=false;
        const adminmess=JSON.parse(window.localStorage.getItem('adminmess'));
        if(adminmess!=null)
        {
            if(adminmess.admin&&adminmess.role&&adminmess.expirtime&&adminmess.token)
            {
                if(adminmess.expirtime>=Date.now())
                {
                    isLogin=true;
                }
                retdata.admin=adminmess.admin;
                retdata.token=adminmess.token;
                retdata.expirtime=adminmess.expirtime;
                retdata.role=adminmess.role;
            }
        }
        if(!isLogin)
        {
            window.localStorage.removeItem('adminmess');
            window.location.href='/login'
        }
    }
    Axios.post(ServiceUrl+'/api/'+name+'/'+action,retdata,
    ).then(resp=>{
        const data=resp.data;
        if(typeof success=="function")
        {
            success(data);
        }
        if(typeof complete=="function")
        {
            complete(data);
        }
    }).catch(err=>{
        if(typeof fail=="function")
        {
            fail(err);
        }
        if(typeof complete=="function")
        {
            complete(err);
        }
    })
}
export {Post}